import { Component, ElementRef, OnDestroy, OnInit, signal } from '@angular/core';
import { FormGroup,  FormsModule,  NgForm, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { Subscription, switchMap, timer } from 'rxjs';
import { USER_MGMT_DATA_CNST } from '../../../../constants/data.cnst';
import { USER_MGMT_CNST } from '../../../../constants/proj.cnst';
import { isNullOrUndefined } from '../../../../modules/shared';
import { BreadCrumsConstant } from '../../../../modules/shared/components/primeng-breadcrumb/breadcrumb.constants';
import { AppStateService } from '../../../../services/app-state.service';
import { DataService } from '../../../../services/data.service';
import { EnvService } from '../../../../services/env.service';
import { HttpService } from '../../../../services/http.service';
import { UtilsService } from '../../../../services/utils.service';
import { ImportsModule } from '../../../../modules/imports/imports';
import { SkeletonModule } from '../../../../modules/shared/components/skeleton/skeleton.module';
import { RoleValidScopeComponent } from '../role-valid-scope/role-valid-scope.component';
import { StepsModule } from 'primeng/steps';
import { PrimengBreadcrumbComponent } from '../../../../modules/shared/components/primeng-breadcrumb/primeng-breadcrumb.component';
import { IconBuilding, IconLayoutGrid, IconSearch, IconUserPlus } from 'angular-tabler-icons/icons';
import { TablerIconComponent,provideTablerIcons } from 'angular-tabler-icons';
import { CustomPhoneNumberComponent } from '../../../../modules/shared/components/custom-phone-number/custom-phone-number.component';
import { AddCustomerAdminComponent } from '../../../customer/components/add-customer-admin/add-customer-admin.component';
import { StepperModule } from 'primeng/stepper';
import { SearchFilterPipe } from '../../../../pipes/search-filter.pipe';
import { InputTextModule } from 'primeng/inputtext';
import { InputGroupModule } from 'primeng/inputgroup';
import { ButtonModule } from 'primeng/button';
import { TextareaModule } from 'primeng/textarea';
import { SelectModule } from 'primeng/select';



@Component({
  selector: 'lib-role-config',
  templateUrl: './role-config.component.html',
  styleUrls: ['./role-config.component.scss'],
  standalone : true,
  imports : [
    ImportsModule,
    SkeletonModule,
    StepperModule,
    // CustomPhoneNumberComponent,
    StepsModule,
    SearchFilterPipe,
    PrimengBreadcrumbComponent,
    StepsModule,
    TablerIconComponent,
    ReactiveFormsModule,
    FormsModule,
    SelectModule,
    // AddCustomerAdminComponent,
    InputTextModule,
    InputGroupModule,
    ButtonModule,
    TextareaModule,
    SelectModule
  ],providers:[
    provideTablerIcons({
      IconBuilding, IconLayoutGrid, IconSearch, IconUserPlus})
  ]
})
export class RoleConfigComponent implements OnInit, OnDestroy {

  stepConfigB: {
    info: number,
    resources: number,
    scope: number
  } = {
      info: 0,
      resources: 1,
      scope: 2
    };

  resourceTypeMap = USER_MGMT_CNST.RESOURCE_TYPES_MAP;
  searchApi!: string;
  searchWidget!: string;
  searchDashboard!: string;
  searchUrl!: string;
  searchChannel!: string;
  serachOther!: string;
  searchConfig!: {
    api: string,
    widget: string,
    dashboard: string,
    url: string
  };

  disableStep: boolean = true; // or dynamically based on logic


  profileData: any = {};
  isFormNotValid = signal(true);
  customerDetails: FormGroup | any;

  isNameTouched: boolean = false;
  isRoleNameNotValid: boolean = false;

  operation: any;
  userMetaInfo: any;
  applicationList: any[] = [];

  scopeScreenVisible: boolean = false;
  currentTab: string = 'info';
  roleId: any = null;

  roleDetailsJson: any = {};
  initScope: any[] = [];
  updatedRoleScope: any[] = [];

  initialResourceActionIdsBackup: any[] = [];
  scopeEndPoint: string = '';
  resourceList: any = null;
  actionColumns: any[] = [];
  mappedResourcesListToRole: any[] = [];
  resourcesListOfApplication: any[] = [];
  resourceTypes: string[] = [];
  initialResourceActionIds: any[] = [];

  subscriptions: Subscription[] = [];

  globalResourceCheck: boolean = true;
  initialApplicationId: any = null;
  intialResources: any = null;
  deleteResource: any[] = [];
  actionNameMapping: any = USER_MGMT_CNST.ACTION_NAME_MAPPING
  loading = signal(false);
  validScope: boolean = true;
  activeStep: number = 0;
  isApplicationExists: boolean = false;
  isScopeClickable: boolean = true;
  items : { [key: string]: MenuItem[] } = BreadCrumsConstant;
  roleLoading = signal(false);
  isApplicationTouched!: boolean;
  isApplicationNameSelected!: boolean;
  isScopeChanged!: boolean;
  isEdit: boolean = true;
  roleForm: any;

  isAddUpdateButtonClicked : boolean = false;

  constructor(
    private httpSrv: HttpService,
    private utilsSrv: UtilsService,
    private appStateSrv: AppStateService,
    private envService: EnvService,
    private dataSrv: DataService,
    private router: Router,
    private activateRoute: ActivatedRoute,
    private messageService: MessageService,
    private el: ElementRef
  ) { }

  get f() {
  return this.roleForm.controls;
}

// onFormSubmit(nextCallback: () => void): void {
//   // your form logic here

//   // call the callback when form is successfully submitted
//   if (this.roleForm.valid) {
//     // perform some action
//     nextCallback();
//   }
// }


  
  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
  }

  ngOnInit(): void {
    this.inItMethod();
    this.updateBreadcrumb(this.operation);
  }

  async inItMethod() {
    const queryParamRef = this.activateRoute.queryParams.subscribe(async (params: any) => {
      this.customerDetails = this.appStateSrv.getCurrentCustomerInfo();
      this.operation = params['operation'];

      if (this.operation == USER_MGMT_CNST.ROLE_MODULE_OPERATIONS.ADD_ROLE) {
        this.activeStep = 0;
      } else if (this.isUpdateOrViewRoleOperation(this.operation)) {
        this.setActiveStep(params);
        await this.handleRoleOperation(params);
      }
      this.userMetaInfo =  localStorage.getItem("metaInfo")
      this.userMetaInfo = JSON.parse(this.userMetaInfo);
      setTimeout(() => {
        this.loadApplications();
      }, 100);
      if (this.operation === USER_MGMT_CNST.ROLE_MODULE_OPERATIONS.UPDATE_ROLE) {
        this.applicationValueChanged();
      }
      this.utilsSrv.disableStepper(this.isScopeClickable);
    });
    this.subscriptions.push(queryParamRef);
  }

  isUpdateOrViewRoleOperation(operation: string): boolean {
    return operation === USER_MGMT_CNST.ROLE_MODULE_OPERATIONS.UPDATE_ROLE ||
      operation === USER_MGMT_CNST.ROLE_MODULE_OPERATIONS.VIEW_ROLE;
  }

  async handleRoleOperation(params: any) {
    const isProfileDataExists = this.utilsSrv.isObjectNotNullAndEmpty(this.appStateSrv.getProfileData());
    this.loading.set(true);
    let roleId = params['roleId'];
    this.roleId = roleId;
    let roleData: any;
    if (!isProfileDataExists) {
      const options = {
        'uriParams': {
          roleId
        }
      }
      let roleInfo = await this.dataSrv.getRoleInfoById(options);
      if (this.utilsSrv.isObjectNotNullAndEmpty(roleInfo)) {
        const { response } = roleInfo;
        roleData = response;
        this.initialApplicationId = response.applicationId
      }
    } else {
      const { info } = this.appStateSrv.getProfileData();
      roleData = info;
    }
    if (this.utilsSrv.isObjectNotNullAndEmpty(roleData)) {
      this.buildProfileData(roleData);
      this.roleDetailsJson = roleData.roleDetailsJson || { validScopes: [] };
      this.initScope = this.roleDetailsJson.validScopes || [];
    } else {
      const options = {
        'uriParams': {
          roleId
        }
      }
      let roleInfo = await this.dataSrv.getRoleInfoById(options);
      if (this.utilsSrv.isObjectNotNullAndEmpty(roleInfo)) {
        const { response } = roleInfo;
        roleData = response;
        this.initialApplicationId = response.applicationId;
        this.buildProfileData(roleData);
        this.roleDetailsJson = roleData.roleDetailsJson || { validScopes: [] };
        this.initScope = this.roleDetailsJson.validScopes || [];
      }
    }
  }

  setActiveStep(params: any) {
    if (this.operation === 'edit' || this.operation === 'view') {
      this.currentTab = params['config'];
      type StepConfigKeys = keyof typeof this.stepConfigB;

      // Ensure params['config'] is a valid key of stepConfig
      const configKey = params['config'];
      const currentTab = configKey as StepConfigKeys;
      this.activeStep = this.stepConfigB[currentTab];
    }
  }


  ngAfterViewInit() {
    this.userTypeLoggedIn();
  }
  
  updateBreadcrumb(operation: string) {
    if (this.items && this.items['config']) {
      const label = 
        operation === 'view' ? 'View Roles' :
        operation === 'edit' ? 'Edit Roles' :
        'Add Roles'; // Default value
  
      // Ensure the second item exists; if not, add it
      if (this.items['config'].length < 2) {
        this.items['config'].push({ label, routerLink: '/usermgmt/roles'  });
      } else {
        // Update existing item at index 1
        this.items['config'][1].label = label;
      }
  
      // Replace the array to ensure change detection
      this.items['config'] = [...this.items['config']];
    }
  }
  
  userTypeLoggedIn() {
    if (this.appStateSrv.getLoggedInUserType() === USER_MGMT_CNST.LOGGED_IN_USER_TYPES.superAdmin) {

      const listItems = this.el.nativeElement.querySelectorAll('ul > li');
      listItems.forEach((li: HTMLElement, index: number) => {
        const stepperAction = li.querySelector('.p-stepper-action');
        if (stepperAction && index === 2) {
          stepperAction.classList.add('disabled');
        }
      });
    }
  }

  disableScopeWhenNoRoleIsAssigned() {
    const elements = document.getElementsByClassName('p-stepper-action');
    if (!this.isScopeClickable) {
      elements[2]?.classList.add('p-disabled');
    } else {
      elements[2]?.classList.remove('p-disabled');
    }
  }

  onToggleTab(tab: string, stepClick: any) {
    const tabs = Object.keys(this.stepConfigB);
    if (this.roleId) {
      this.currentTab = tab;
      tabs.forEach((tabs: any, index) => {
        if (tabs === tab) {
          this.router.navigate(['usermgmt', 'roles', 'config'], {
            queryParams: {
              config: tab
            },
            queryParamsHandling: 'merge'
          })
        }
      });
    }
  }
  onlyAlphabet(event: any, maxLength: number, allowSpecialChars: boolean) {
    const pattern = /^[a-zA-Z0-9\s]+$/;
    let inputChar = String.fromCharCode(event.charCode);
    let inputText = event.target.value;
    // Check if the key is not a backspace
    if (event.keyCode === 8) {
      return; // Allow backspace without any checks
    }
    // Check for maximum length first
    if (inputText.length >= maxLength) {
      event.preventDefault();
      return; // Prevent further processing if max length is reached
    }
    // Conditional character validation
    if (allowSpecialChars && !pattern.test(inputChar)) {
      event.preventDefault(); // Prevent invalid character input
    }
  }

  space(event: any) {
    if (event.code === 'Space') {
      let inputText = event.target.value;
      let caretPosition = event.target.selectionStart;
      if (caretPosition === 0 || inputText.charAt(caretPosition - 1) === ' ' || (inputText.charAt(caretPosition - 1) === ' ' && inputText.charAt(caretPosition) === ' ')) {
        event.preventDefault();
      }
    }
  }

  inputHasOnlyAlphabets(event: any) {
    let inputText = event?.target?.value;
    this.isNameTouched = true;
    this.isFormNotValid.set(inputText.length <= 0);
  }

  buildProfileData(response: any) {
    let { roleName, applicationId, description, applicationName, customerName } = response;

    this.profileData['firstName'] = roleName;
    this.profileData['selectedApplication'] = applicationId;
    this.profileData['applicationName'] = applicationName;
    this.profileData['description'] = description;
    this.profileData['customerName'] = customerName;
  }

  loadApplications() {
    this.httpSrv.makeGetApiCall('APP_LIST', this.envService.baseUrl).subscribe({
      next: (response: any) => {
        this.applicationList = response;
        if (this.roleId && response.statusCode != 401) {
          this.applicationChange();
        }
      },
      complete: () => { },
      error: () => {
        this.applicationList = []
      }
    });
  }

  validateApplicationSelection() {
    this.isApplicationTouched = true; // Mark the field as touched.
    this.isApplicationNameSelected = this.profileData.selectedApplication; // Check if no application is selected.
  }

  applicationValueChanged() {
    if (this.operation == USER_MGMT_CNST.ROLE_MODULE_OPERATIONS.UPDATE_ROLE) {
      this.isFormNotValid.set(false);
    }
    this.isApplicationExists = false;
  }

  applicationChange() {

    this.scopeEndPoint = '';

    let applicationId = this.profileData.selectedApplication;

    //* Store a backup of the resource action ids of the initial resource
    //* which was loaded so that when application is switched we can track
    //* and compare if some of these ids are to be moved to deleted array
    if (this.initialResourceActionIdsBackup.length === 0) {
      this.initialResourceActionIdsBackup = [...this.initialResourceActionIds];
    }

    const selectedApplicationInfo = (this.applicationList || []).find(
      (app: any) => app.applicationId == this.profileData.selectedApplication
    );
    if (selectedApplicationInfo) {
      this.scopeEndPoint = selectedApplicationInfo?.scopeEndPoint || '';
    } else {
      this.isApplicationExists = true;
    }
    let options = {
      replaceParams: {
        // REPLACE_ROLE_ID: this.modalData.role_id,
        REPLACE_APP_ID: applicationId
      },
    };
    const roleOptions = {
      replaceParams: {
        REPLACE_ROLE_ID: this.roleId,
      }
    }

    this.resourceList = null;
    this.intialResources = null;
    this.actionColumns = [];
    this.mappedResourcesListToRole = [];
    this.resourcesListOfApplication = [];
    this.loading.set(true);
    this.httpSrv.makeGetApiCall('APP_RSC_LIST', this.envService.baseUrl, options).subscribe({
      next: (appResources: any) => {
        this.resourcesListOfApplication = appResources.response ? appResources.response : [];
        this.mappedResourcesListToRole = [];
        this.httpSrv.makeGetApiCall("ROLE_RSC_LIST", this.envService.baseUrl, roleOptions).subscribe({
          next: (roleResource: any) => {
            this.mappedResourcesListToRole = roleResource.response ? roleResource.response : [];
            this.resourceList = this.formatResponse(this.resourcesListOfApplication);
            this.intialResources = this.formatResponse(this.resourcesListOfApplication);
            this.initialResourceActionIds = this.storeRsrcActionIds(true);
          },
          complete: () => {
            this.loading.set(false);
          },
          error: () => {
            this.loading.set(false);
          }
        });
      },
      complete: () => { },
      error: () => {
        this.resourceList = this.formatResponse(this.resourcesListOfApplication);
        this.applicationValueChanged();
        this.loading.set(false);
      }
    });
  }


  formatResponse(data: any[]) {    
  let resourceTypeDataMap: {
    "APIs": any[],
    "URLs": any[],
    "Dashboards": any[],
    "Widgets": any[],
    "Channels": any[],
    "Others": any[]
  } = {
    "APIs": [],
    "URLs": [],
    "Dashboards": [],
    "Widgets": [],
    "Channels": [],
    "Others": []
  };
  
  this.resourceTypes = USER_MGMT_CNST.RESOURCE_TYPES;
  
  for(let row of data) {
    let filterData = this.findFilterData(row.resourceId);
    for(let action of row.actionsInfo) {
      this.assignActionStatus(action, filterData);
      
      // Default to 'Dashboards' if resourceTypeName is not provided
      const resourceType = row.resourceTypeName || 'Dashboards';
      
      if (resourceTypeDataMap.hasOwnProperty(resourceType)) {
        const index = resourceTypeDataMap[resourceType as keyof typeof resourceTypeDataMap]
          .findIndex((r: any) => r.resourceId === row.resourceId);
        if(index == -1) {
          resourceTypeDataMap[resourceType as keyof typeof resourceTypeDataMap].push(row);
        }
      }
    }
  }
  
  return resourceTypeDataMap;
}

   findFilterData(resourceId: any) {
    return this.mappedResourcesListToRole.find((r: any) => r.resourceId === resourceId);
  }

   assignActionStatus(action: any, filterData: any) {
    action['isAssigned'] = filterData ? 
      filterData.actionsInfo.some((a: any) => a.resourceActionId === action.resourceActionId) : 
      false;
  }

  onFormSubmit(form: NgForm) {
  if (form.valid && this.profileData.selectedApplication) {
    this.isAddUpdateButtonClicked = true;
    // Do your save logic here
    
    //*If description was not entered set it to blank string
    form.value.description = isNullOrUndefined(form.value.description) ? '' : form.value.description;
    let customerDetails = {};
    if (this.userMetaInfo?.['customerId'] && this.userMetaInfo?.['customerName']) {
      customerDetails = {
        customerId: this.userMetaInfo['customerId'],
        customerName: this.userMetaInfo['customerName']
      }
    } else {
      customerDetails = {
        customerId: null,
        customerName: null
      }
    }

    this.addProfile(form.value, customerDetails);
  } else {
    form.form.markAllAsTouched();
  }

  }

  addProfile(profileInfo: any, customerDetails: any) {
    
    setTimeout(() => {
      this.isAddUpdateButtonClicked = false
    }, 2000);
    
    let { name, description, application } = profileInfo;

    let postData = {
      "meta": {
        roleName: name,
        description,
        applicationId: application ?? this.profileData?.selectedApplication,
        customerId: customerDetails['customerId']
      }
    };
    this.loading.set(true);
    this.httpSrv.makePostApiCall("ADD_PROFILE", postData, this.envService.baseUrl).subscribe({
      next: (response: any) => {
        if (response.statusCode === 201) {
          this.roleId = response.response;
          this.activeStep = 1;
          this.messageService.add({ severity: 'success', summary: 'Success', detail: response.message });
          this.isScopeClickable = false;
          this.router.navigate(['usermgmt', 'roles', 'config'], {
            queryParams: {
              operation: USER_MGMT_CNST.ROLE_MODULE_OPERATIONS.UPDATE_ROLE,
              config: 'resources',
              roleId: this.roleId
            }
          })
        }
      },
      complete: () => {
        this.loading.set(false);
      },
      error: (err: any) => {
        let { error } = err;
        this.loading.set(false);
        if (this.utilsSrv.isObjectNotNullAndEmpty(error)) {

          if (error.message.includes("roles_role_name_application_id_key")) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: "Role name already exists" });

          } else {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: err.error.message });
          }
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: "Failed to create role" });
        }
      }
    });
  }

  selectAll(type: string, searchTerm: string) {
    this.deleteResource = [];
    const normalizedSearchTerm = searchTerm?.toLowerCase() || '';
    if (!this.resourceList[type]) {
        return; 
    }
    for (let resource of this.resourceList[type]) {
       
        if (resource.resourceName && resource.resourceName.toLowerCase().includes(normalizedSearchTerm)) {
            for (let action of resource['actionsInfo']) {
                action['isAssigned'] = true;  
            }
        } 
    }
}



clearAll(type: string, searchTerm: string) {
  this.deleteResource = [];

  const normalizedSearchTerm = searchTerm?.toLowerCase() || '';

  if (!this.resourceList[type]) {
      return; 
  }
  for (let resource of this.resourceList[type]) {
      if (resource.resourceName && resource.resourceName.toLowerCase().includes(normalizedSearchTerm)) {
          for (let action of resource['actionsInfo']) {
              action['isAssigned'] = false;
          }
      }
  }
}


  resourceToggle(type: any, resourceName: any, j: any) {

    const i = this.resourceList[type].findIndex((list: any) => list?.resourceName === resourceName);

    if (i === -1) return;

    this.resourceList[type][i]['actionsInfo'][j]['isAssigned'] = !this.resourceList[type][i]['actionsInfo'][j]['isAssigned'];
    // Update read and edit access based on the current state of resources.
    this.manageResourcesReadEditAccess(type, i, j);
    // Retrieve the resource action ID for the specified action.
    const resourceActionId = this.resourceList[type][i]['actionsInfo'][j]['resourceActionId'];
    // Find the index of this resourceActionId in the deleteResource array.
    // If the action is now unassigned and not already in deleteResource, add it.
    // If the action is  assigned and exists in deleteResource, remove it.
    const index = this.deleteResource.indexOf(resourceActionId);
    if (!this.resourceList[type][i]['actionsInfo'][j]['isAssigned'] && index === -1) {
      this.deleteResource.push(resourceActionId);
    } else if (this.resourceList[type][i]['actionsInfo'][j]['isAssigned'] && index !== -1) {
      this.deleteResource.splice(index, 1);
    }
    this.actionColumns.forEach((item) => {
      // Check if the action exists in the resource's actions and sync enabled state.
      if (this.resourceList[i]["actions"][item.action_name]) {
        this.resourceList[i]["actions"][item.action_name]["enabled"] = this.resourceList[i]["enabled"];
        item["enabled"] = this.resourceList.every((a: { [x: string]: { [x: string]: { [x: string]: any; }; }; }, _: any, [b]: any) => {
          const actionA = a["actions"][item.action_name];
          const actionB = b["actions"][item.action_name];
          const enabledA = actionA ? actionA["enabled"] : true;
          const enabledB = actionB ? actionB["enabled"] : true;
          return enabledA === enabledB;
        });
      }
      this.updateGlobalCheck();
    });
  }

  // If Edit access is provided then Read acess should be provided. and If Read access revoked then edit access should be revoked
  manageResourcesReadEditAccess(type: any, i: any, j: any) {
    const actionInfo = this.resourceList[type][i]['actionsInfo'];
    const { actionName: actionType, isAssigned } = actionInfo[j];
  
    // If Edit access is granted (checking with USER_PERMISSION_ACTION.EDIT && isAssigned),
    // Read access should also be granted.
    // If Read access is revoked (checking with USER_PERMISSION_ACTION.READ && !isAssigned),
    // Edit access should also be revoked.
    if ((actionType ===  USER_MGMT_CNST.USER_PERMISSION_ACTION.EDIT && isAssigned) || 
        (actionType === USER_MGMT_CNST.USER_PERMISSION_ACTION.READ && !isAssigned)) {
      
      // If either condition is true, then:
      // - If actionType is EDIT, set newAssignedValue to true, 
      //   and the isAssigned value for READ should also be set to true.
      // - If actionType is READ, set newAssignedValue to false,
      //   and the isAssigned value for EDIT should also be set to false.
      const newAssignedValue = actionType === USER_MGMT_CNST.USER_PERMISSION_ACTION.EDIT;
      actionInfo.forEach((item: any) => {
        item['isAssigned'] = newAssignedValue
        // If Resource is  un-assigned(newAssignedValue is false) it needs to add to deleteResource array
        if(!newAssignedValue) {
          this.deleteResource.push(item['resourceActionId']);
        }
      });
    }
  }

  updateGlobalCheck() {
    this.globalResourceCheck = !!(this.resourceList.every((a: { [x: string]: any; }, _: any, [b]: any) => a["enabled"] === b["enabled"]) &&
      this.resourceList.length && this.resourceList[0]["enabled"]);
  }

  update() {

    this.isAddUpdateButtonClicked = true;
    setTimeout(() => {
      this.isAddUpdateButtonClicked = false
    }, 2000);

    //? Enable this and the below if statement if you want the condition
    //? that atleast one resource should be selected for a role definition
    // let isAtleastOneResourceSelected = this.resourceList.some(item => item.enabled);

    let metaInfo = {
      roleName: this.profileData.firstName,
      description: this.profileData.description ? this.profileData.description : null,
      status: true,
      applicationId: this.profileData.selectedApplication
    }


    //* Get the resource action ids for those resources
    //* where atleast one action is selected
    let finalResult = this.storeRsrcActionIds();

    let deletedIds = this.initialResourceActionIds.filter(
      (x: any) => !finalResult.includes(x) || this.initialApplicationId != this.profileData.selectedApplication
    );

    let newlyAddedIds = finalResult.filter((x) => !this.initialResourceActionIds.includes(x));

    //* Application has been changed in the dropdown
    //* Hence move the resources of initial application to
    //* deleted resource action ids
    if (this.initialApplicationId !== this.profileData.selectedApplication) {
      deletedIds = [...deletedIds, ...this.initialResourceActionIdsBackup];
    }

    let isMetaInfoChanged = this.getMetaInfoStr(this.profileData) !== this.getMetaInfoStr(metaInfo);

    let metaInfoDetails = isMetaInfoChanged ? metaInfo : null;

    const details = {
      operation: USER_MGMT_CNST.OPERATION_TYPES.PROFILE.EDIT_PROFILE,
      postData: {
        role_id: this.roleId,
        addResourceActions: newlyAddedIds && newlyAddedIds.length > 0 ? newlyAddedIds : [],
        // deleteResourceActions: this.initialApplicationId !== this.profileData.selectedApplication ? deletedIds : this.deleteResource,
        deleteResourceActions: deletedIds,
        meta: metaInfoDetails,
        roleDetailsJson: {
          validScopes: this.isScopeChanged ? this.updatedRoleScope : this.initScope
        }
      },
    };
    this.updateProfile(details.postData);
  }

  storeRsrcActionIds(valueInside: boolean = false) {
    const list: any[] = [];

    //* Iterate over each resource for the application.For each resource
    //* push only the resource action id where the READ / EDIT action is enabled
    Object.keys(this.resourceList).forEach((item: any) => {
      this.resourceList[item].forEach((resource: any) => {
        if (resource) {
          const index = this.mappedResourcesListToRole.findIndex((res: any) => res.resourceId == resource.resourceId);
          if (valueInside) {
            if (index != -1) {
              resource['actionsInfo'].forEach((action: any) => {
                if (action['isAssigned']) {
                  list.push(action['resourceActionId']);
                }
              })
            }
          } else {
            resource['actionsInfo'].forEach((action: any) => {
              if (action['isAssigned']) {
                list.push(action['resourceActionId']);
              }
            })
          }

        }
      })
    });
    return list;
  }



  getMetaInfoStr(userInfo: any) {
    if (!userInfo) return '';

    return JSON.stringify({
      applicationId: userInfo.applicationId,
      description: userInfo.description,
      roleName: userInfo.roleName,
      status: userInfo.status
    })
  }

  setPostAndOptions(profileInfo: any) {
    if (!profileInfo) {
      return { postData: null, options: null };
    }
    
    const { addResourceActions, deleteResourceActions, meta, roleDetailsJson } = profileInfo;
    if (!addResourceActions.length && !deleteResourceActions.length && !meta && !roleDetailsJson) {
      return { postData: null, options: null };
    }
    
    let postData: any = {
      addResourceActions,
      deleteResourceActions
    }
    
    if (roleDetailsJson) {
      postData.roleDetailsJson = roleDetailsJson
    }

    if (profileInfo.meta) {
      postData.meta = profileInfo.meta;
    }

    return {
      postData,
      options: {
        replaceParams: {
          "REPLACE_ROLE_ID": profileInfo.role_id
        }
      }
    }
  }

  updateProfile(profileInfo: any) {
    this.loading.set(true);
    const { postData, options } = this.setPostAndOptions(profileInfo);
    if (postData && options) {
      this.httpSrv.makePutApiCall('UPDATE_PROFILE', postData, this.envService.baseUrl, options).pipe(
        switchMap((response: any) => {
          // Handle the successful response
          this.appStateSrv.setWasPageScrolled(false);
          this.messageService.add({ severity: 'success', summary: 'Success', detail: response.message });
          // Return an observable that emits after 1000ms delay
          return timer(1000);
        })
      ).subscribe({
        next: () => {
          // Execute navigation or further actions after the delay
          if (this.currentTab === 'scope') {
            this.navigateToProfilesList();
          } else if (this.currentTab === 'resources') {
            // if (this.appStateSrv.getLoggedInUserType() === USER_MGMT_CNST.LOGGED_IN_USER_TYPES.superAdmin) {
            //   this.navigateToProfilesList();
            // } else {
            //   this.scopeDefinationScreen();
            // }
            this.navigateToProfilesList();
          } else {
            this.router.navigate(['usermgmt', 'roles', 'config'], {
              queryParams: { config: 'resources' },
              queryParamsHandling: 'merge'
            });
          }
          this.loading.set(false);
          this.isScopeClickable = true;
        },
        error: (response: any) => {
          // Handle the error response
          this.loading.set(false);
          this.messageService.add({ severity: 'error', summary: 'Error', detail: response.error.message });
        }
      });
    } else {
      // Handle the case when postData or options are not available
      this.messageService.add({ severity: 'error', summary: 'Error', detail: USER_MGMT_DATA_CNST.TOASTER_MSG.UPDATE_ROLE_ERROR_NO_FIELD });
    }
  }

  scopeDefinationScreen() {
    this.router.navigate(['usermgmt', 'roles', 'config'], {
      queryParams: {
        config: 'scope'
      },
      queryParamsHandling: 'merge'
    })
  }

  updateScope(data: any) {
    this.isScopeChanged = true;
    if (data.length === 0) {
      this.validScope = true;
      this.updatedRoleScope = data;
      return;
    }

    const hierarchyScopeData = data.filter((scope : any) => scope.scopeType === 'HIERARCHY');
    const nonHierarchyScopeData = data.filter((scope : any) => scope.scopeType === 'NON_HIERARCHY');

    const invalidHierarchy = hierarchyScopeData.length > 0 &&
      (hierarchyScopeData.some((scope : any) => scope?.scopeName === '') ||
        hierarchyScopeData.filter((scope : any) => scope?.scopeName !== '').length !== 2);

    const invalidNonHierarchy = nonHierarchyScopeData.length > 0 &&
      nonHierarchyScopeData.some((scope : any) => scope.scopeName === '' || scope.scopeName === null || scope.scopeName?.length == 0);

    this.validScope = !(invalidHierarchy || invalidNonHierarchy || (hierarchyScopeData.length === 0 && nonHierarchyScopeData.length === 0));
    data.forEach((scope : any) => {
      if (scope.scopeType == "" || scope.scopeName == "") {
        this.validScope = false;
      }
    });
    this.updatedRoleScope = data;
  }

  navigateToProfilesList() {
    this.router.navigate(['usermgmt', 'roles']);
  }

  nvaigateToEdit() {
    this.router.navigate(['usermgmt', 'roles', 'config'], {
      queryParams: {
        operation: 'edit'
      },
      queryParamsHandling: 'merge'
    })
  }

  getSelectedApplicationName(): string {
    const selectedApp = this.applicationList.find(
      app => app.applicationId === this.profileData.selectedApplication
    );
    return selectedApp?.applicationName;
  }

  getLoader(loading:boolean){
    this.roleLoading.set(loading);
  }


  onEditClick() {
    this.isEdit = true;
  }

  onSecondStepSubmit() {
    this.activeStep = 2
  }

  
}
function nextCallback() {
  throw new Error('Function not implemented.');
}





